import { render, staticRenderFns } from "./axisRankCharts.vue?vue&type=template&id=7fc4a4ff&scoped=true"
import script from "./axisRankCharts.vue?vue&type=script&lang=js"
export * from "./axisRankCharts.vue?vue&type=script&lang=js"
import style0 from "./axisRankCharts.vue?vue&type=style&index=0&id=7fc4a4ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc4a4ff",
  null
  
)

export default component.exports